<template>
  <div id="app">
    <v-idle @idle="idlelogout()" :duration="3600" v-if="!fullScreen"/>
    <v-dialog v-if="pop"><v-alert v-model="pop"
    dismissible
      text
      color="deep-orange"
      icon="mdi-fire"
      max-width="300"
    >
		<v-col class="shrink">
			<v-btn
				color="info"
				outlined
			>
				Okay
			</v-btn>
		</v-col>
    </v-alert>
    </v-dialog>
    <v-app app light>
      <!-- Top Bar for app navigation -->
      <v-app-bar clipped-left app class="elevation-1" :color="dark ? 'black' : '#cce6ff'" v-if="!kiosk && !fullScreen" height="50" >
        <v-app-bar-nav-icon @click="drawer = !drawer">  
        </v-app-bar-nav-icon>
        <v-btn icon @click="switchtheme">
          <v-icon>mdi-invert-colors</v-icon>
        </v-btn>
        <v-btn icon @click.stop="mini = !mini">
          <v-icon v-if="mini">mdi-chevron-right</v-icon>
          <v-icon v-else>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn v-if="!loggedIn" text @click="login()"> Login </v-btn>
        <!-- <v-btn v-if="!loggedIn" text @click="signup()"> Sign Up </v-btn> -->
        <v-spacer></v-spacer>

        <v-menu v-if="loggedIn" @click.native="openuser = !openuser" offset-y> 
        <template v-slot:activator="{on, attrs}">
        <v-btn text v-bind="attrs" v-on="on">
          <v-icon left>mdi-account</v-icon>
        </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title text :style="{cursor: 'pointer'}" @click="logout(); openuser=false">Logout</v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item>
            <v-list-item-title :style="{cursor: 'pointer'}" @click="changepw(); openuser=false">Change Password</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
        <v-btn text v-if="loggedIn" @click="supportreq = !supportreq;openBugFiler()">
          <v-icon left>mdi-face-agent</v-icon>
            {{'support' | phrasemap}}
        </v-btn>
        <v-toolbar-title>Entrinsia Cortex V{{version}}</v-toolbar-title>
      </v-app-bar>

      <v-main>
        <router-view></router-view>
      </v-main>
      <!-- <v-footer app  fixed height="40" v-if="loggedIn && !kiosk"  class="font-weight-medium" z-index=10>
        <div v-if="bottomSlot != null">
 
          </div>
        <v-row align="center" class="text-center" cols="12">
          {{mqttConnected ? 'Connected to Server' : 'Server Disconnected'}}
          <span style="margin-left: 4px" :class="{reddot: !mqttConnected, greendot: mqttConnected}"></span>
          <v-spacer></v-spacer>
          {{origLoggedinUser.firstname}} {{origLoggedinUser.lastname}} ({{ loggedinOrg.fullName ? loggedinOrg.fullName : loggedinOrg.name}})
          <v-spacer></v-spacer>
          <v-btn v-if="loggedIn" icon @click.stop="kiosk = !kiosk">
            <v-icon>mdi-television</v-icon>
          </v-btn>
          <img v-if="loggedIn && logo != ''" :src = "logo">
        </v-row>
      </v-footer> -->
      <v-fab-transition>
        <v-btn
          v-if="loggedIn && kiosk && !fullScreen"
          fab
          small
          dark
          bottom
          left
          class="v-btn--example"
          @click.stop="kiosk = !kiosk"
        >
          <v-icon>mdi-television</v-icon>
        </v-btn>
      </v-fab-transition>
    <v-navigation-drawer
      style="margin-top: 3px; "
      inset
        v-if="!kiosk && !fullScreen && loggedIn && menuIsBuilt"
        enable-resize-watcher
        permanenet
        fixed
        app
        clipped
        hide-overlay
        height="100%"
        v-model="drawer"
        width="300"
        :mini-variant.sync="mini"
      >
      <v-list dense>
        <template v-for="(item, idx) in loginMenuItems">
        <v-list-group
          :value="false"
          no-action
          :key = "idx"
          :prepend-icon="item.icon"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title><h4 style="fontSize: 1.2em;">{{item.title | phrasemap}}</h4></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(sub, i) in item.items"
            :key="i"
            link
            :to="sub.path"
          >
            <v-list-item-title >
              <h5  class="pl-4" style="fontSize: 1.2em; fontWeight: 500 !important;">{{sub.title | phrasemap}}</h5>
            </v-list-item-title>

            <v-list-item-icon>
              <v-icon class="pa-2 pm-2" v-text="sub.icon"></v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
        </template>
      </v-list>
    <template v-slot:append v-if="allowed_facilities != null && allowed_facilities.length > 1">
        <div class="pa-2">
          <v-select 
            outlined 
            v-model="current_org" 
            label="Facility" 
            block 
            :items="allowed_facilities"
            item-text="name"
            item-value="code"
          >
          </v-select>
        </div>
      </template> 
    </v-navigation-drawer>
     <v-footer app  fixed height="40" v-if="loggedIn && !kiosk && !fullScreen"  class="font-weight-medium" style="z-index: 1000">
        <div v-if="bottomSlot != null">
 
          </div>
        <v-row align="center" class="text-center" cols="12">
          {{mqttConnected ? 'Connected to Server' : 'Server Disconnected'}}
          <span style="margin-left: 4px" :class="{reddot: !mqttConnected, greendot: mqttConnected}"></span>
          <v-spacer></v-spacer>
          {{origLoggedinUser.firstname}} {{origLoggedinUser.lastname}} ({{ loggedinOrg.fullName ? loggedinOrg.fullName : loggedinOrg.name}})
          <v-spacer></v-spacer>
          <v-btn v-if="loggedIn" icon @click.stop="kiosk = !kiosk">
            <v-icon>mdi-television</v-icon>
          </v-btn>
          <img v-if="loggedIn && logo != ''" :src = "logo">
        </v-row>
    </v-footer>
      <confirm ref="confirm"></confirm>
      <METRCCreds ref="metrccreds" :state_license="state_license" :metrc_key="metrc_key" :error_metrc="error_metrc" :error_state="error_state"></METRCCreds>
    </v-app>
  </div>
</template>

<script>
import { sync } from "vuex-pathify"
import Login from "../../coreui/components/Login"
import Confirm from "../../coreui/library/Confirm"
import METRCCreds from "../../cortex/src/library/METRCCreds"
import BuildRoutes from '@/mixins/buildRoutes.js'
import axiosInstances from '@/../../coreui/server/axiosInstances.js'
import LoginMixin from '@/mixins/loginUtils'
import PopupMixin from '@/mixins/MessagePopup'
import utils from '@/../../cortex/src/mixins/utils.js'
export default {
  components: {
    Login,
    Confirm,
    METRCCreds
  },
  mixins: [
    BuildRoutes,
    LoginMixin,
    PopupMixin,
    utils
  ],
  data: () => ({
    pop: false,
    openuser: false,
    kiosk: false, 
    drawer: true,
    mini: false,
    logo: '',
    state_license: null,
    metrc_key: null,
    state: null,
    allowed_facilities: null,
    current_org: null,
    error_metrc: false,
    error_state: false,
    initial_facility: null,
    menuIsBuilt: false,
		bgScrollColor: 'blue',
  }),
  computed: {
    changePWDialog: sync('login/changePWDialog'),
    facility: sync('login/facility'),
    version: sync('packageVersion'),
    supportreq: sync('misc/supportreq'),
    mqttConnected: sync('mqtt/mqttConnected'),
    mqttNotification: sync('mqtt/notification'),
    dark: sync("misc/dark"),
    bottomSlot: sync('misc/bottomSlot'),
    loginDialog: sync("login/loginDialog"),
    loginMessage: sync('login/loginMessage'),
    loggedIn: sync("login/loggedIn"),
    loggedinUser: sync("login/loggedinUser"),
    loggedinOrg: sync("login/loggedinOrg"),
    origLoggedinUser: sync("login/origLoggedinUser"),
    origLoggedinOrg: sync("login/origLoggedinOrg"),
    loader: sync("login/loader"),
    loginWelcomeBackground: sync('login/loginWelcomeBackground'),
    loginDialogBackground: sync('login/loginDialogBackground'),
    loginMenuItems: sync('login/loginMenuItems'),
    initialLoginComplete: sync('login/initialLoginComplete'),
    orgSensors: sync('orgSensors'),
    citionary: sync('dictionary'),
    fullScreen: sync('login/fullScreen')
		// theme() {
		// 	const bodyElement = document.getElementsByTagName("body")[0];
		// 	if (this.$vuetify.theme.dark == true) {
		// 		bodyElement.classList = "dark";
		// 	} else {
		// 		bodyElement.classList = "light";
		// 	}
		// 	print(bodyElement)
		// 	return this.$vuetify.theme.dark ? "dark" : "light";
		// },
  },
  methods: {
    changepw() {
      // change user password
      try {
        this.$router.push('/')
      } catch(ex) {}
      this.changePWDialog = true
    },
    openBugFiler() {
      if (this.supportreq) this.$router.push('/SupportTicket')
      else this.$router.go(-1)
    },
    switchtheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      this.dark = this.$vuetify.theme.dark
      this.setUserPreference('light', !this.dark)
    },
    logout(timed) {
      this.processLogout()
      if (!timed) this.loginMessage = null
      this.$router.replace('/Welcome')
    },
    idlelogout () {
      if (!this.loggedIn) return
      console.log('Logged out due to inactivity')
      this.loginMessage = "You have been logged out due to extended inactivity. Please login again."
      this.logout(true)
    },
    login() {
      try {
        this.$router.push('/')
      } catch(ex) {

      }
      this.loginDialog = true
    },
    signup() {
      try {
        this.$router.push('/SignUp')
      } catch (ex) {

      }
    },
    async getLogo () {
      var logo = ''
      if (!this.loggedinOrg.name) return
      try {
        var url = '/getfiles/'+this.loggedinOrg.name+'/logo.png'
        logo = await axiosInstances.apiServer.get(url, {responseType: 'arraybuffer'})
        return logo
      } catch (ex) {
        return ''
      }
    },

 
  },
  watch: {
    initialLoginComplete: {
      async handler (val) {
        console.log('initial login complete: ', val)
				console.log(this.loggedinOrg)
				// check if additional login requirements are satisfied
        if (val) {
          this.loader = this.$loading.show({
            container: null, //full page
            onCancel: null, // can't cancel
            loader: 'dots', // 'spinner' , 'dots' or 'bars',
            opacity: 0.75,
            backgroundColor: '#000000',
            color: '#475fb3',
            zIndex: 999,
          })
          if (!await this.parentLogin()) {
						console.log('wrong account type')
						this.$toasted.show('Your account type does not have web acess: please contact support@entrinsia.com')
						this.processLogout()
					}
          this.loader.hide()
        }
      }
    },
    initial_facility: {
      async handler (val) {
        if (val == null) return
        this.elog('trace', 'Initial facility is: {}', val)()
        this.current_org = val
        let isLight = await this.getUserPreference('light')
        if (isLight) this.dark = false
        this.$vuetify.theme.dark = this.dark
      }
    },
    async current_org (val) {
      if (val == null) return
      await this.setFacilityCreds(val)
      let c = localStorage.getItem('continue')
      if (c) {
        localStorage.removeItem('continue')
        this.$router.push(c).catch(() => {})
      }
      this.facility = val
    },
    async mqttNotification (val) {
      if (val == null) return
      let res = await axiosInstances.origApiServer.get('/dt/v1/inf_global/' + val)
      if (res == null || res.data ==null) return 
      let msg = res.data
      this.popupMessage(msg)
      this.mqttNotification = null
    },
    dark (val) {
    //   const bodyElement = document.getElementsByTagName("body")[0];
    //   if (val) {
    //     bodyElement.classList = "dark";
    //   } else {
    //     bodyElement.classList = "light";
    //   }
		// 	console.log(bodyElement)
    }
  },
  mounted() {
    if (localStorage.getItem('kiosk')) {
      this.kiosk = true
      localStorage.removeItem('kiosk')
    }
    this.$root.$confirm = this.$refs.confirm.open
    // provide images for the app
    this.loginWelcomeBackground = require('@/assets/background.jpg')
    this.loginDialogBackground = require('@/assets/cortex.jpg')
    const x = () =>  import('!raw-loader!@/assets/html/bulkTag.html')
  },
};
</script>

<style >
html { 
  overflow-y: auto !important; 
  }
.row {
  margin-bottom: unset !important;
  margin-top: unset !important;
}
.v-application--wrap {
  min-height: 98vh !important;
  overflow-y: auto !important;
}
.v-main {
  padding-top: 30px !important;
  padding-bottom: 0px !important;
  padding-right: 0px !important;
  /* overflow-y: hidden !important; */
  /* max-height: 90%; */
}

body.darkScrollbar::placeholder {
	/* background-color: #202324; */
  color: #b2aba1;
}
body.darkScrollbar::-webkit-scrollbar {
  background-color: #202324;
  color: #aba499;
}
html.darkScrollbar::-webkit-scrollbar-track {
  background-color: #202324;
  color: #aba499;
}
body.darkScrollbar::-webkit-scrollbar-thumb {
  background-color: #454a4d;
}
body.darkScrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #575e62;
}
body.darkScrollbar::-webkit-scrollbar-thumb:active {
  background-color: #484e51;
}
body.darkScrollbar::-webkit-scrollbar-corner {
  background-color: #181a1b;
}
body.darkScrollbar::selection {
  background-color: #004daa !important;
  color: #e8e6e3 !important;
}
body.darkScrollbar::-moz-selection {
  background-color: #004daa !important;
  color: #e8e6e3 !important;
}
body.darkScrollbar input:-webkit-autofill,
body.darkScrollbar textarea:-webkit-autofill,
body.darkScrollbar select:-webkit-autofill {
  background-color: #555b00 !important;
  color: #e8e6e3 !important;
}

/* width */
 /* ::-webkit-scrollbar {
    width: 10px;
  }


  ::-webkit-scrollbar-track {
    background: #202324 ;
  }

 
  ::-webkit-scrollbar-thumb {
    background: #454a4d;
  }

 
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }  */

::-webkit-scrollbar {
  width: 15px;
}

::-webkit-scrollbar-track {
  background: var(--bg-scroll-color);/*#e6e6e6;*/
  border-left: 1px solid #dadada;
}

::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border: solid 2px #e6e6e6;
  border-radius: 7px;
}

::-webkit-scrollbar-thumb:hover {
  background: indigo;
}

/* .dark::-webkit-scrollbar {
  width: 15px;
}

.dark::-webkit-scrollbar-track {
  background: #202020;
  border-left: 1px solid #2c2c2c;
}

.dark::-webkit-scrollbar-thumb {
  background: #3e3e3e;
  border: solid 3px #202020;
  border-radius: 7px;
}

.dark::-webkit-scrollbar-thumb:hover {
  background: white;
} */
</style>
<style scoped>
#app {
  overflow-x: hidden;
  overflow-y: auto !important;
}

@import  "../../coreui/styles/basic.css";
</style>


